module.exports = __webpack_public_path__ + "static/media/i-9.71a57e98.svg";